import { render, staticRenderFns } from "./Accreditations.vue?vue&type=template&id=963e74d6&scoped=true&"
import script from "./Accreditations.vue?vue&type=script&lang=js&"
export * from "./Accreditations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963e74d6",
  null
  
)

export default component.exports